module.exports = __webpack_public_path__ + "assets/img/icon-owl.png";